import styled from "styled-components";

export const TermsComponentMainDiv = styled.main``;

export const TermsComponentHeroMainDiv = styled.section`
  > div {
    display: flex;
    gap: 10px;
    width: 100%;
    padding: 210px 40px 100px;
    align-items: center;
    justify-content: center;
  }
  .terms-container {
    display: flex;
    flex-flow: column;
    gap: 120px;
    max-width: 810px;
    width: 100%;
    flex: 1;
    max-width: 1140px;
  }

  .terms-header-container {
    display: flex;
    flex-flow: column;
    gap: 12px;
    max-width: 810px;
    width: 100%;
    flex: 1;
    max-width: 1140px;
    align-items: center;
    justify: center;
  }

  .terms-header-text-container {
    width: 100%;
    flex: 1;
    max-width: 700px;
    > h1 {
    }
  }
  .terms-body-container {
    display: flex;
    flex-flow: column;
    gap: 120px;
    width: 100%;
    flex: 1;
    height: min-content;
  }
`;
export const TermsComponentdetailsItemDiv = styled.div`
  display: flex;
  width: 100%;
  flex: 1;
  gap: 24px;
  align-items: start;
  justify-content: space-between;

  .terms-left-col {
    display: flex;
    flex-flow: column;
    gap: 8px;
    position: sticky;
    top: 150px;
    width: 100%;
    flex: 1;
    max-width: 190px;
  }
  .terms-text-wrapper {
    > h3 {
      font-size: 26px;
      font-weight: 400;
    }
    p {
      opacity: 0.7;
      line-height: 1.4em;
    }
  }
  .terms-right-col {
    display: flex;
    width: 61%;
    display: flex;
    flex-flow: column;
    gap: 40px;
  }
 
  .terms-texts-container {
    display: flex;
    flex-flow: column;
    gap: 24px;
    
    width: 100%;
    flex: 1;
    align-itmes: center;
  }
  .terms-body-text-container {
    display: flex;
    flex-flow: column;
    gap: 40px;
    width: 100%;
    flex: 1;
    align-itmes: center;
  }
  .terms-detail-text-wrapper {
    > h3 {
      font-size: 40px;
    }
    > p {
     >b{
          opacity:1;
          font-size:18px;
          color:white;

     }
    }
  }
 
  .terms-detail-detail-wrapper {
    display: flex;
    align-items: center;
    gap:10px;
    width:100%;
  }
    .terms-details-detial-wrapper{
      display: flex;
    align-items: center;
    gap:8px;
    width:100%;
    flex-flow:column;
    }
`;
